import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Menu, X } from "lucide-react";
import { useState } from "react";

export const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const loc = useLocation();
  const [open, setOpen] = useState(false);

  const link = (to, label, tid) => (
    <Link
      data-testid={tid}
      to={to}
      onClick={() => setOpen(false)}
      className={`text-sm tracking-wide transition-colors ${
        loc.pathname === to ? "text-[#C5A059]" : "text-[#8A8F98] hover:text-[#EBE9E1]"
      }`}
    >
      {label}
    </Link>
  );

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-[#0A0B0E]/70 border-b border-white/10">
      <div className="px-6 md:px-12 mx-auto max-w-7xl flex items-center justify-between h-20">
        <Link to="/" data-testid="nav-logo" className="flex flex-col leading-none">
          <span className="font-serif text-2xl text-[#EBE9E1]">Official T.K. Chiba Shihan Archive</span>
          <span className="text-[10px] tracking-[0.3em] uppercase text-[#C5A059]">Presented by Birankai North America</span>
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {link("/library", "Library", "nav-library")}
          {link("/about", "About", "nav-about")}
          {user && user.role === "admin" && (
            <Link data-testid="nav-admin" to="/admin"
              className={`text-sm tracking-wide px-3 py-1 border transition-colors ${
                loc.pathname === "/admin" ? "border-[#C5A059] text-[#C5A059]" : "border-[#C5A059]/40 text-[#C5A059]/90 hover:border-[#C5A059] hover:text-[#C5A059]"
              }`}>
              Admin
            </Link>
          )}
          {user ? (
            <div className="flex items-center gap-6">
              {link("/account", "Account", "nav-account")}
              <button data-testid="nav-logout" onClick={() => { logout(); navigate("/"); }}
                className="text-sm text-[#8A8F98] hover:text-[#8B2626] transition-colors">Sign out</button>
            </div>
          ) : (
            <div className="flex items-center gap-6">
              {link("/login", "Sign in", "nav-login")}
              <Link data-testid="nav-join" to="/register"
                className="btn-primary px-6 py-2 text-sm font-medium">Request Access</Link>
            </div>
          )}
        </nav>

        <button data-testid="nav-mobile-toggle" className="md:hidden text-[#EBE9E1]" onClick={() => setOpen(!open)}>
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/10 px-6 py-6 flex flex-col gap-5 bg-[#0A0B0E]">
          {link("/library", "Library", "nav-library-m")}
          {link("/about", "About", "nav-about-m")}
          {user && user.role === "admin" && link("/admin", "Admin", "nav-admin-m")}
          {user ? (
            <>
              {link("/account", "Account", "nav-account-m")}
              <button data-testid="nav-logout-m" onClick={() => { logout(); navigate("/"); setOpen(false); }}
                className="text-left text-sm text-[#8B2626]">Sign out</button>
            </>
          ) : (
            <>
              {link("/login", "Sign in", "nav-login-m")}
              {link("/register", "Request Access", "nav-join-m")}
            </>
          )}
        </div>
      )}
    </header>
  );
};
